import arrowleft from "@Images/NewUI/Vector.png";
import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import Shield from "../../../../src/Images/NewUI/Shield.png";
import cross from "../../../../src/Images/NewUI/cross.png";
import Pdfimg from "../../../../src/Images/NewUI/pdf.jpg";
import PlusPdfimg from "../../../../src/Images/NewUI/pdfplus.jpg";
import questionImage from '../../../../src/Images/questionpng.png';
import ToastMsg from "../../../../src/helper/ToastMsg";
import { payme_bank_statement_heading, payme_bank_statement_list } from "../../../../src/helper/modalConstant";
import DisclaimerImg from "../../../Images/NewUI/disclaimer.png";
import { getUserDetail } from "../../../Redux/GeneralDetails/action";
import { getDocumentStatus, getWebViewEkycUrl, preSignedURL, upldateDocumentStatus, uploadDocsToS3 } from "../../../Redux/Manual_Kyc_Details/action";
import ModalBox from "../../../helper/modalBox";
import { withRouter } from "../../../hooks/withRouter";
import { Loader } from "../../NewUI/Common/Loader";
import { BANK_STATEMENT } from "../Common/constant";

const Bankstatement = (props) => {
  const navigate = useNavigate();
  const [modalState, setModalState] =  useState(false)
  const [bankstatement, setBankStatement] = useState([]);
  const [presigned_urls, setPresigned_urls] = useState({});
  const [uploadpdf, setUploadpdf] = useState(false);
  const [pdfpassword, setPdfpassword] = useState("");
  const [loader, setLoader] = useState(false);
  const [isBtnEnable, setIsBtnEnable] = useState(false);
  const [makeBtnEnable, setMakeBtnEnable] = useState(false);
  
  const [secondPlusShow, setSecondPlusShow] = useState(false);
  const [secondpdfenable, setSecondpdfenable] = useState(false);

  const [thirdPlusShow, setThirdPlusShow] = useState(false);
  const [thirdpdfenable, setThirdpdfenable] = useState(false);
  
  
  
  

  useEffect(() => {
    
    let token = props.token||localStorage.getItem("gpay_token");

    let { id } = props?.userDetail && props?.userDetail?.user_detail;
    let data = {
      s3_path: [`bank_statement/${id}/statement0.pdf`, `bank_statement/${id}/statement1.pdf`,`bank_statement/${id}/statement2.pdf`],
    };
    props
      .preSignedURL({
        s3_path: data,
        token: token,
      })
      .then((res) => {
        // console.log(res);
        setPresigned_urls(res);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  }, []);

  const makeFormData = (result, pdf_value) => {
    // console.log(result, pdf_value, "result***");
    let formData = new FormData();
    Object.keys(result?.fields).forEach((key) => {
      let value = result?.fields[key];
      formData.append(key, value);
    });
    formData.append("file", pdf_value);
    return formData;
  };

  const base64ToByteArray = (base64String) => {
    const byteCharacters = atob(base64String);
    var byteArray = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteArray[i] = byteCharacters.charCodeAt(i);
    }
    return new Uint8Array(byteArray);
  };

  const handlePdfPassword = (e) =>{
    setPdfpassword(e.target.value)
    // console.log(pdfpassword,"pdfpassword");
  }
  const handleBankStatement = (blob, index) => {
    setLoader(true)
  
    fileToDataUri(blob)
      .then((blob) => {
        uploadBankStatement(blob, index);
      })
      .catch((err) => {
        // console.log(err, "errorrrr handle bank statement");
        setLoader(false);
        if (err.response?.status === 401) {
          window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
        let error = err?.response?.data?.error;
        ToastMsg(error, "error");
        // console.log(err);
      });
  };
  const handlepdfdelete = () =>{
    setIsBtnEnable(!isBtnEnable)
  }
  
  const deletethirdpdf = () =>{
    setThirdPlusShow(true)
  }

  const deletesecondpdf = () =>{
    setSecondPlusShow(true)
    setThirdpdfenable(false)
  }
  const deletefirstpdf = () =>{
    setMakeBtnEnable(false)
    setSecondpdfenable(false)
    setSecondpdfenable(false)
    setSecondPlusShow(true)

    setThirdpdfenable(false)
    setThirdPlusShow(false)
  }

  const handlebtnenable = () =>{
    
    setMakeBtnEnable(!makeBtnEnable)
    setSecondpdfenable(true)
    setSecondPlusShow(true)
  }
  const handleclockonfirstplus = ()=>{
    setThirdpdfenable(true)
    setThirdPlusShow(true)
    setSecondPlusShow(false)
  }

  const handleclockonSecondplus = ()=>{
    
    setThirdPlusShow(false)
    
  }

  const fileToDataUri = (file) => {
    const reader = new FileReader();

    return new Promise((resolve, reject) => {
      reader.onload = () => {
        const blob = new Blob([reader.result], { type: file.type });
        resolve(blob);
      };

      reader.onerror = () => {
        reject(reader.error);
      };

      reader.readAsArrayBuffer(file);
    });
  };
  const UploadMultipleForm =  () =>{
    // console.log("event click")
   const uploadPromises = Promise.all( bankstatement.map(async(blob, index) => {
    handleBankStatement(blob, index)}))

  }
 
  const uploadBankStatement = async (blob, index) => {
    let { id } = props.userDetail && props.userDetail.user_detail;
    let token = localStorage.getItem("gpay_token");
    // console.log(token, "uploadtoken");
    let data = {
      image_path: `bank_statement/${id}/statement${index}.pdf`,
      token: token,
    };
    let bs_presigned_data = presigned_urls;
    // console.log(presigned_urls,"uu",presigned_urls?.data, presigned_urls?.data[`bank_statement/${id}/statement${index}.pdf`] )
    let bs_data =  bs_presigned_data?.data[`bank_statement/${id}/statement${index}.pdf`];
    if (bs_presigned_data) {
      //  console.log(bs_data, "bss")
      let formData = makeFormData(bs_data, blob);
     
      formData.append("key", data.image_path);
      props
        .uploadDocsToS3({
          url: bs_data.url,
          formData,
        })
        .then((res) => {
          // console.log(res);
          if (res.status === 204) {
            setLoader(false);
            setIsBtnEnable(true)
            let updated_data = {
              doc_type: "bank_statement",
              path: `bank_statement/${id}/statement${index}.pdf`,
              password : pdfpassword,
            };
            props.upldateDocumentStatus({
              updateStatus: updated_data,
              token: token,
            })
            .then((res) => {
              // console.log(res);
              // alert("hhh")
              // props.history.push("/completeprofilenew");
             
            })
            .catch((err) => {
              setLoader(false);
              if (err.response?.status === 401) {
                window.location.href = "/";
                localStorage.removeItem("gpay_token");
              }
              let error = err?.response?.data?.error;
              ToastMsg(error, "error");
              // console.log(err);
            });

            // alert("jjj")
            navigate("/completeprofilenew");
            
          }
        })
        .catch((err) => {
          // console.log(err, "errorrrr upload bank statement");
          setLoader(false);
          if (err.response?.status === 401) {
            window.location.href = "/";
            localStorage.removeItem("gpay_token");
          }
          let error = err?.response?.data?.error;
          ToastMsg(error, "error");
          // console.log(err);
        });
    }
  };
  // console.log(bankstatement, "bankstatement");
  return (
    <>
  
     {loader ? (
          <div className="loader_cl">
            <Loader />
          </div>
        ) : null}
         <div id="background" className="main_div payme_body">
      <div className="toolbarRespo">
        <div className="pt-2 pb-4 sticky-header mb-mt-25 shadowline width100per plf-20 justifycontentspacebtn align-items-center d-flex">
         <div style={{display:"flex", flexDirection:"row", alignItems:"center"}}>
         <img
            
          style={{marginRight:"20px"}}
            src={arrowleft}
            onClick={() => {
              navigate(-1);
            }}
          />

          <span
            className="boldheading headMarginDec"
            style={{
              //paddingLeft: "80px",
              color: "#152745",
              fontWeight: "1000",
              fontSize: "26px",
            }}
          >
            {BANK_STATEMENT}
          </span>
         </div>
          <img
            onClick={() => {
              setModalState(true);
            }}
            src={questionImage}
          />
        </div>

        <div className="">
            <div className="repaymentdisclaimer2 raiseaticketmargin flex_row ">
                      <img style={{marginRight: 13, marginTop: -19, marginLeft:10}} width={16} height={16} src={DisclaimerImg}></img>
                      <p className="selectrepaymentdatedisclaimercolour ">Please share the bank account statement of your primary account, where most of your earnings/ income/salary is credited, for the last 6 months.</p>
            </div>
        </div>

        <div style={{width:"100%"}} className="cardbottomMargin aligncentrehere">
          <div className="cardstructureupdated mt-23 alignficx max-380 containerheight2 ">
            <div className="newbankstatement">
            <div className="flex_row justifycontent  designfix">
              <div className="flex_row marginTop">
                <h6 className="uploadbankstatementmarginfix">
                  {" "}
                  Upload Bank Statement
                </h6>
              </div>
            </div>

            <div className=" flex_row ">
              <b className="dotstyle">.</b>
              <p className="selectrepaymentdatedisclaimercolour m-r12">
                Verification will take <b>2-3 Business hours</b>{" "}
              </p>
            </div>
            <div className=" flex_row "></div>

            <div className="multiplebankstatementuploadicon">
              <div className={!secondPlusShow ? "flexx ml-20multiplebank mr-20multiplebank":"flexx ml-20multiplebank"}>
                <div>
                  {makeBtnEnable ? (
                    <>
                      <img
                        style={{ marginBottom: "16px", marginTop: "22px" }}
                        width={90}
                        height={90}
                        src={Pdfimg}
                      ></img>
                      <img
                        className={thirdpdfenable?"crossimgfix": "multiplefirstpdf"}
                        style={{ marginBottom: "16px", marginTop: "22px" }}
                        width={18}
                        height={18}
                        onClick={deletefirstpdf}
                        src={cross}
                      ></img>
                    </>
                  ) : (
                    <>
                      <div>
                        <input
                          className="uploadbtnfix"
                          accept=".pdf"
                          type="file"
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file && file.size <= 15 * 1024 * 1024) { // Max size in bytes (5 MB)
                              setBankStatement([...bankstatement, file], handlebtnenable());
                            } else {
                              // Handle error for exceeding file size limit
                              alert("File size exceeds 15 MB limit. Please select a smaller file.");
                            }
                          }}
                        />
                      </div>
                      <img
                        className="uploadplusbtnfixtwo"
                        src={PlusPdfimg}
                      ></img>
                    </>
                  )}
                </div>
              </div>
              <div className="flexx ">
                <div style={{ marginLeft: "-131px" }}>
                  {secondpdfenable ? (
                    secondPlusShow ? (
                      <>
                        <div>
                          <input
                            className="uploadbtnfix"
                            accept=".pdf"
                            type="file"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  if (reader.result.byteLength <= 15 * 1024 * 1024) {
                                    
                                    setBankStatement([...bankstatement, file], handleclockonfirstplus());
                                  } else {
                                    
                                    alert("File size exceeds 15 MB limit. Please select a smaller file.");
                                  }
                                };
                                reader.readAsArrayBuffer(file);
                              }
                            }}
                          />
                        </div>
                        <img
                          className="uploadplusbtnfixupload uploadplusbtfixone"
                          src={PlusPdfimg}
                        ></img>
                      </>
                    ) : (
                      <>
                        <img
                          style={{
                            marginBottom: "16px",
                            marginTop: "22px",
                            marginLeft: "131px",
                            // paddingLeft: "10px",
                          }}
                          width={90}
                          height={90}
                          src={Pdfimg}
                        ></img>
                        <img
                          className={!secondpdfenable?"crossimgfix" :"multiplesecondpdf"}
                          style={{ marginBottom: "16px", marginTop: "22px" }}
                          width={18}
                          height={18}
                          onClick={deletesecondpdf}
                          src={cross}
                        ></img>
                      </>
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="flexx">
                <div>
                  {thirdpdfenable ? (
                    thirdPlusShow ? (
                      <>
                        <div>
                          <input
                            className="uploadbtnfixlastpdf"
                            accept=".pdf"
                            type="file"
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) {
                                const reader = new FileReader();
                                reader.onloadend = () => {
                                  if (reader.result.byteLength <= 15 * 1024 * 1024) {
                                    
                                    setBankStatement([...bankstatement, file], handleclockonSecondplus());
                                  } else {
                                    
                                    alert("File size exceeds 15 MB limit. Please select a smaller file.");
                                  }
                                };
                                reader.readAsArrayBuffer(file);
                              }
                            }}
                            style={{
                              margin: '0',
                              padding: '0',
                              border: 'none',
                              outline: 'none',
                              width: '100%' // Optionally, set width to fill the container
                            }}
                          />
                        </div>
                        <img
                          className="uploadplusbtnfix "
                          src={PlusPdfimg}
                        ></img>
                      </>
                    ) : (
                      <>
                        <img
                          style={{ marginBottom: "16px", marginTop: "22px", marginLeft:"16px" }}
                          width={90}
                          height={90}
                          src={Pdfimg}
                        ></img>
                        <img
                          className="crossimgfixlast"
                          style={{ marginBottom: "16px", marginTop: "22px" }}
                          width={18}
                          height={18}
                          onClick={deletethirdpdf}
                          src={cross}
                        ></img>
                      </>
                    )
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            

            <div className={!thirdpdfenable? "pt-0 pb-0 amount_select pdfpassword ": " pt-0 pb-0 amount_select pdfpasswordfix"}>
              <div className="floatleft">
                <label for="Enter_Amount" style={{   fontSize:16, fontWeight: 600}}>
                  Password:<span className="ifanydesign"> (If any)</span>
                </label>
              </div>
              <span >
                <input
                  type="password"
                  className="enter_amount enterpassword"
                  placeholder=""
                  name="amount"
                  value={pdfpassword}
                  onChange={handlePdfPassword}
                />
                {/* {console.log("amount", amount)} */}
              </span>
            </div>
            </div>

            {makeBtnEnable ? (
              <div
                className="Estatementbtn"
                style={{ opacity: "1" }}
                onClick={()=>{UploadMultipleForm()}}
              >
                Submit
              </div>
            ) : (
              <div className="Estatementbtn blurbtnestatement" style={{ opacity: "0.5" }}>
                Submit
              </div>
            )}


<div style={{marginBottom:"-50px"}} className="grncolour sticktobottom">
            <img
              style={{ marginRight: 10 }}
              width={18}
              height={18}
              src={Shield}
            ></img>
            Your data is 100 % safe and secure
          </div>
          </div>
         
         
        </div>
      </div>
      {modalState && (
        <ModalBox
          statusDes={true}
          heading={payme_bank_statement_heading}
          List={payme_bank_statement_list}
          open={true}
          onChange={(props) => {
            setModalState(props);
          }}
          imagesVisible={true}
        />
      )}
    </div>
    </>
   
  );
}


const mapStateToProps = (state) => {
  return {
    user: state.user,
    userDetail: state.userDetail,
  };
};

export default withRouter(connect(mapStateToProps, {
  getWebViewEkycUrl,
  getDocumentStatus,
  getUserDetail,
  preSignedURL,
  uploadDocsToS3,
  upldateDocumentStatus,
})(Bankstatement));